import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Input,
  Row,
  Label,
  Card,
  CardBody,
  CustomInput,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  AxiosAPI,
  getGroupID,
  setSelectedGroup,
} from '../../../../../../helpers/AxiosAPI';
import { gAPI_Messenger } from '../../../../../../constants/APIs';
import Select from 'react-select';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
export default function MenuSetting({
  settings,
  saveIntegration,
  integrationProperties,
  lang,
  propertyId,
}) {
  const [requestNames, setRequestNames] = useState([]);
  const [menuSetting, setMenuSetting] = useState({
    isEnabled: false,
    requestName: '',
    menus: [],
  });
  const [selectedOptions, setselectedOptions] = useState([]);
  const [menus, setMenus] = useState([]);

  const handleMenuSettingEnabled = (e) =>
    setMenuSetting({ ...menuSetting, isEnabled: e });

  const handleMenuRequestName = (e) =>
    setMenuSetting({ ...menuSetting, requestName: e.target.value });

  const handleMenus = (e, index) => {
    let list = [...menuSetting.menus];
    let obj = list.filter((f, i) => index === i);
    if (obj.length > 0) {
      let options = [...selectedOptions];
      if (options.filter((f, i) => index === i).length === 0) {
        options.push(e);
      } else {
        options[index] = e;
      }
      setselectedOptions(options);
      list[index].itemIds = e.map((m) => m.value);
    }
    setMenuSetting({ ...menuSetting, menus: list });
  };

  useEffect(() => {
    if (settings !== undefined && settings.apiConfigurations !== undefined) {
      if (settings.apiConfigurations.length > 0) {
        let lst = settings.apiConfigurations.map((m) => m.requestName);
        setRequestNames(lst);
      }
    }
    if (integrationProperties.length === 1) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Messenger}?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${lang}&orderBy=${'Title'}&search=${''}`,
      }).then((res) => {
        let lst = [];
        if (res.data.length > 0) {
          res.data.map((m) =>
            lst.push({ label: m.title, key: m.id, value: m.id })
          );
          if (settings !== undefined && settings.menuSetting !== undefined) {
            let menuList = settings.menuSetting?.menus;
            let options = [];
            if (menuList !== undefined && menuList.length > 0) {
              menuList.map((m) => {
                if (m.itemIds !== undefined && m.itemIds.length > 0) {
                  let optionList = [];
                  res.data.filter((f) => {
                    if (m.itemIds.filter((i) => i === f.id).length > 0)
                      optionList.push({
                        label: f.title,
                        key: f.id,
                        value: f.id,
                      });
                  });
                  options.push(optionList);
                }
              });
            }
          }
        }
      });
    } else {
      let lst = [...menus];
      let options = [...selectedOptions];
      const mentuData = integrationProperties.map(async (m) => {
        return AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Messenger}?propertyId=${m}&groupId=${getGroupID()}&lang=${lang}&orderBy=${'Title'}&search=${''}`,
        }).then((res) => {
          if (res.data.length > 0) {
            res.data.map((m) =>
              lst.push({ label: m.title, key: m.id, value: m.id })
            );
          }
        });
      });

      Promise.all(mentuData).then((res) => {
        if (settings !== undefined && settings.menuSetting !== undefined) {
          let menuList = settings.menuSetting?.menus;
          if (menuList !== undefined && menuList.length > 0) {
            menuList.map((m) => {
              if (m.itemIds !== undefined && m.itemIds.length > 0) {
                let optionList = [];
                lst.filter((f) => {
                  if (m.itemIds.filter((i) => i === f.value).length > 0)
                    optionList.push({
                      label: f.label,
                      key: f.value,
                      value: f.value,
                    });
                });
                options.push(optionList);
              }
            });
          }
        }
        setMenus(lst);
        setselectedOptions(options);
        if (settings !== undefined && settings.menuSetting !== undefined) {
          setMenuSetting(settings.menuSetting);
        }
      });
    }
  }, [settings]);

  const handleChange = (index, e) => {
    let list = [...menuSetting.menus];
    let obj = list.filter((f, i) => index === i);
    if (obj.length > 0) {
      obj = obj[0];
      obj[e.target.name] = e.target.value;
      list[index] = obj;
    }
    setMenuSetting({ ...menuSetting, menus: list });
  };

  const addMenu = () => {
    let list = [...menuSetting.menus];
    list.push({
      name: 'name',
      condition: '',
      itemIds: [],
    });
    setMenuSetting({ ...menuSetting, menus: list });
  };

  const handleSave = () => {
    saveIntegration({ menuSetting: menuSetting });
  };

  const removeMenu = (index) => {
    let list = [...menuSetting.menus];
    list = list.filter((f, i) => index !== i);
    let options = [...selectedOptions];
    options = options.filter((f, i) => index !== i);
    setselectedOptions(options);
    setMenuSetting({ ...menuSetting, menus: list });
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Manage Web Widget Menus</h6>
          </div>
          <Separator className="mb-3" />
          <div className="row mt-1 ml-2 mb-3">
            <Colxx md="12" className="mb-2">
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2 float-right"
                checked={menuSetting?.isEnabled}
                name="isEnabled"
                onChange={(e) => handleMenuSettingEnabled(e)}
              />
            </Colxx>
            <Colxx md="12" className="mb-2">
              <Input
                type="select"
                name="requestName"
                value={menuSetting?.requestName}
                onChange={handleMenuRequestName}
              >
                <option value="">Please Select</option>
                {requestNames.map((r) => (
                  <option value={r}>{r}</option>
                ))}
              </Input>
            </Colxx>
            <Colxx md="12">
              <Row>
                {menuSetting.menus !== undefined &&
                  menuSetting.menus.length > 0 && (
                    <Fragment>
                      {menuSetting.menus.map((m, index) => (
                        <Fragment>
                          <Colxx md="12" className="mb-2">
                            <Row>
                              <Colxx md="12" className="mb-2">
                                <Label>Condition</Label>
                                <Input
                                  type="text"
                                  name="condition"
                                  placeholder="Condition"
                                  value={m.condition}
                                  onChange={(e) => handleChange(index, e)}
                                ></Input>
                              </Colxx>
                              <Colxx md="12">
                                <Select
                                  isMulti={true}
                                  components={{ Input: CustomSelectInput }}
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  name="form-field-name"
                                  placeholder="Select Menus"
                                  options={menus}
                                  value={
                                    selectedOptions.filter(
                                      (f, i) => i === index
                                    ).length > 0
                                      ? selectedOptions.filter(
                                        (f, i) => i === index
                                      )[0]
                                      : []
                                  }
                                  onChange={(val) => {
                                    handleMenus(val, index);
                                  }}
                                />
                              </Colxx>
                              <Colxx md="12" className="text-right">
                                <Button
                                  onClick={() => removeMenu(index)}
                                  className="mt-4"
                                  color="danger"
                                  size="xs"
                                  outline
                                >
                                  -
                                </Button>
                              </Colxx>
                            </Row>
                          </Colxx>
                        </Fragment>
                      ))}
                    </Fragment>
                  )}

                <Colxx md="12" className="text-left">
                  <Button onClick={addMenu} color="primary" size="xs" outline>
                    {' '}
                    + Add Condition
                  </Button>
                </Colxx>
              </Row>
            </Colxx>
          </div>
          <Separator className="mb-2" />
          <Colxx md="12" className="text-center mb-2">
            <Button
              onClick={() => handleSave()}
              color="primary"
              size="xs"

            >
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
